module.exports = __webpack_public_path__ + "img/1.1.8758f983.jpg";